module.exports = __webpack_public_path__ + "static/media/pic1.428bc128.jpg";